import { useEffect } from 'react';

/* 客户端注入 JSON-LD 到 <head>（生产站为纯 SPA，无 SSR / Helmet）。
   同一 id 重复注入前先移除旧节点，避免堆积；data 变化按序列化字符串比对重注入。 */
export default function useJsonLd(id, data) {
  const json = data ? JSON.stringify(data) : '';
  useEffect(() => {
    if (!json) return undefined;
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = id;
    script.text = json;
    document.head.appendChild(script);
    return () => {
      const el = document.getElementById(id);
      if (el) el.remove();
    };
  }, [id, json]);
}
